import { Box, Typography } from '@mui/material'
import React from 'react'

export default function OrgaDescription({data}) {
  return (
    <Box sx={{ bgcolor: "#f9f9f9" }}>
        <Box
        key={1}
        id={`tlm-threat-1`}
        sx={{
            width: "210mm",
            margin: "auto",
            marginBottom: "20px",
            // pageBreakAfter: "always",
            boxShadow: 3,
            borderRadius: 2,
            bgcolor: "#f9f9f9",
            padding: "20px",
            boxSizing: "border-box",
            overflow: "hidden",
        }}
        >
        {/* Main Title */}
            <Typography
                sx={{
                textAlign: "start",
                marginBottom: "10px",
                fontWeight: "bold",
                }}
                variant='h5'
            >
                Section 1 : Company Risk Profile
            </Typography>
            <Typography
                sx={{
                textAlign: "start",
                fontWeight: "bold",
                }}
                variant='h6'
            >
                1.1 Organisation Context
            </Typography>

            <Typography
                sx={{
                    textAlign: "start",
                    padding: 2,
                   
                    fontSize: "16px",
                    whiteSpace: 'pre-line' // This preserves line breaks
                }}
                variant='body2'
            >
                {data?.orga_description?.replace(/\. /g, '.\n\n')}
            </Typography> 
        </Box>
    </Box>
  )
}
